/* 업무 */
import api from './Api';
import * as common from './common';
import { store } from '../redux/store';
import { FrameAction } from '../redux/slice/frame/root_main_slice';
import { isMobile } from 'react-device-detect';


export function callAsyncSvc(requestData, options) {
    let jwtToken = {};
    if(localStorage.getItem("jwtToken")){
        jwtToken = localStorage.getItem("jwtToken");
    }else{
        jwtToken = "";
    }
    
    let config = {
        headers: { Authorization : jwtToken, ...common.getHeader(options.txCd) },
    };

    if (options.txCd === 'TRUSRS0007') {
        config.headers.instCd = '002';
    }

    if(options.responseType){
        config = {...config, responseType : options.responseType}
    }

    if(options.contentType){
        config = {...config, contentType : options.contentType}
    }

    if (options && !options.noLoading) {
        common.showLoading(true);
    }
    api.post('', requestData, config)
        .then(response => {
            common.showLoading(false);

            if(options.txCd !== 'TRUSRR0001' && options.txCd !== 'TRCOMR0001' && options.txCd !== 'TRUSRS0007'){
                localStorage.setItem("jwtToken", response.headers.authorization);
                store.dispatch(FrameAction.setJwtToken(response.headers.authorization));
            }

            if(!['TRUSRR0001', 'TRCOMR0001', 'TRUSRS0007'].includes(options.txCd) && common.isUserTempPswdYn() === 'Y'){
                if(config.headers.scrnId !== 'usr0103p1' && config.headers.scrnId !== 'usr0103p2'){
                    const param = {
                        title : '위드정보 확인',
                        contents: '임시 비밀번호 입니다.\n 비밀번호 변경 화면으로 이동합니다.',
                        accept : () => {
                            const params = {};
            
                            params.title = '비밀번호 변경';
                            params.popupId = 'usr0103p1';
                            params.isNotClose = true;
                            params.cancel =  () => {
                                const _param = {
                                    title : '위드정보 확인',
                                    contents: '비밀번호 변경이 완료되었습니다.\n로그인 페이지로 이동합니다.',
                                    accept : () => {
                                        common.logout();
                                    }
                                };
                
                                common.openAlert(_param);
                                return;
                            };
                            params.props = { 
                                empNo: common.getEmpNo(),
                                
                            };
                            
                            common.openPopup(params);
                            return;
                        },
                    };
    
                    common.openAlert(param);
                    return;
                }
            }

            if (options && options.success && typeof options.success === 'function') {
                // 파일다운로드
                if (options.txCd === "TRFRMR0004") {
                    options.success(response);
                }
                // blob 다운로드 대응
                else if (config.responseType === 'blob') {
                    options.success(response);
                } else {
                    options.success(response.data.data);
                }
            }
        })
        .catch(error => {
            common.showLoading(false);
            console.log(error);
            if( error.response.status === 401 ){
                const param = {
                    title : '확인',
                    contents: '로그인 세션이 만료되었습니다.<br/>로그인 페이지로 이동합니다.',
                    accept: () => {
                        common.closeAllPopup();
                        common.logout();
                    }
                };

                common.openError(param);
            }

            if (error.response && error.response.data && !common.isEmptyString(error.response.data.message)) {
                const param = {
                    title : '에러',
                    contents: error.response.data.message,
                };

                common.openError(param);
            }
        });
}


export async function callSyncSvc(requestData, options) {
    let jwtToken = {};
    if(localStorage.getItem("jwtToken")){
        jwtToken = localStorage.getItem("jwtToken");
    }else{
        jwtToken = "";
    }
    let config = {
        headers: { Authorization : jwtToken, ...common.getHeader(options.txCd) },
    };

    if(options.responseType){
        config = {...config, responseType : options.responseType}
    }

    if(options.contentType){
        config = {...config, contentType : options.contentType}
    }

    if (options && !options.noLoading) {
        common.showLoading(true);
    }
    let result;

    try {
        result = await api.post('', requestData, config);
        common.showLoading(false);
    } catch (err) {
        common.showLoading(false);
        return { success : false, ...err };
    }

    return { success : true, ...result.data.data };
}